export default __webpack_public_path__ + "static/media/NotConfirmed.03517f46.svg";